export const getPossibleMatches = (searchString: string) => {
  const query = `SELECT ?resource ?resourceTitle ?author ?authorTitle WHERE {
      {
      ?resource a <http://scta.info/resource/person> .
}
      UNION{
      ?resource a <http://scta.info/resource/expression> .
      ?resource <http://scta.info/property/level> '1' .
}
      ?resource <http://purl.org/dc/elements/1.1/title> ?resourceTitle .
      FILTER (CONTAINS(LCASE(?resourceTitle), LCASE("${searchString}")))
      OPTIONAL{
        ?resource <http://www.loc.gov/loc.terms/relators/AUT> ?author .
        ?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .
        }
    }`
  return query
}